module.exports = __webpack_public_path__ + "static/media/test.c59511bf.jpeg";